"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inlineSpacedStyles = void 0;
var tslib_1 = require("tslib");
var emotion_1 = require("emotion");
var appStylesBase_1 = require("../appStylesBase");
var inlineSpacedStyles = function () { return (0, emotion_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding: ", ";\n\n  > * {\n    display: inline-block;\n    margin: ", ";\n    vertical-align: middle;\n  }\n"], ["\n  padding: ", ";\n\n  > * {\n    display: inline-block;\n    margin: ", ";\n    vertical-align: middle;\n  }\n"])), (0, appStylesBase_1.appStylesBase)().spacing.smaller, (0, appStylesBase_1.appStylesBase)().spacing.smaller); };
exports.inlineSpacedStyles = inlineSpacedStyles;
var templateObject_1;
